export function optimizeNameList(graphNames) {
  if (!graphNames) return [];
  let names = [];
  graphNames.forEach((tempName) => {
    const elementId = tempName.name;
    names.push({
      id: elementId,
      name: tempName.comment || tempName.name,
      fulltext: "range," + tempName.name,
      value: tempName.value,
      scope: tempName.scope,
      type: "range",
      visible: tempName.visible,
    });
  })
  return names;
}
